var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGridOneActive = function SvgIconGridOneActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.333 7.601V3.818c0-1.175-.533-1.65-1.858-1.65h-3.367c-1.325 0-1.858.475-1.858 1.65v3.775c0 1.183.533 1.65 1.858 1.65h3.367c1.325.008 1.858-.467 1.858-1.642M18.333 16.975v-3.367c0-1.325-.533-1.858-1.858-1.858h-3.367c-1.325 0-1.858.533-1.858 1.858v3.367c0 1.325.533 1.858 1.858 1.858h3.367c1.325 0 1.858-.533 1.858-1.858M8.75 7.601V3.818c0-1.175-.534-1.65-1.859-1.65H3.525c-1.325 0-1.858.475-1.858 1.65v3.775c0 1.183.533 1.65 1.858 1.65h3.367c1.324.008 1.858-.467 1.858-1.642M8.75 16.975v-3.367c0-1.325-.534-1.858-1.859-1.858H3.525c-1.325 0-1.858.533-1.858 1.858v3.367c0 1.325.533 1.858 1.858 1.858h3.367c1.324 0 1.858-.533 1.858-1.858"
  })));
};
export default SvgIconGridOneActive;